// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Subheading} from 'sail/Text';
import './BeforeAfterTable.scss';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  before: {
    id: 'docsApp.components.beforeAfterTable.before',
    description: 'Label for what the code looked like before',
    defaultMessage: 'Before',
  },
  after: {
    id: 'docsApp.components.beforeAfterTable.after',
    description: 'Label for what the code looks like after',
    defaultMessage: 'After',
  },
});

type BeforeAfterTableProps = {|
  beforeNodes: React.Node,
  afterNodes: React.Node,
|};

export const BeforeAfterTable = ({
  beforeNodes,
  afterNodes,
}: BeforeAfterTableProps) => {
  return (
    <Box className="BeforeAfterTable">
      <Box padding={{bottom: 4}} className="BeforeAfterTable-header">
        <Box className="BeforeAfterTable-before">
          <Subheading>
            <FormattedMessage {...messages.before} />
          </Subheading>
        </Box>
        <Box>
          <Subheading>
            <FormattedMessage {...messages.after} />
          </Subheading>
        </Box>
      </Box>
      <Box className="BeforeAfterTable-container">
        <Box className="BeforeAfterTable-diff BeforeAfterTable-before">
          {beforeNodes}
        </Box>
        <Box className="BeforeAfterTable-diff">{afterNodes}</Box>
      </Box>
    </Box>
  );
};
